/// <amd-module name="CodeCoverage/CodeCoverageTab/Components/CodeCoverageHtmlSummary" />
import * as React from 'react';
import { VssComponent } from 'VSS/Platform/Layout';


export interface ICodeCoverageHtmlSummaryProps {
    modernBrowserAvailable: boolean;
    codeCoverageSummaryLink: string;
}

export class CodeCoverageHtmlSummary extends VssComponent<ICodeCoverageHtmlSummaryProps, {}> {
    public render(): JSX.Element {
        // sandbox="" on an iFrame will apply all restrictions
        return (
            <div className="code-coverage-summary-part">
                {
                    this.props.modernBrowserAvailable ?
                        <div className="code-coverage-frame-part" >
                            <iframe sandbox="" src={this.props.codeCoverageSummaryLink} className="code-coverage-summary-frame" />
                        </div>
                    :
                        ""
                }
            </div>
        );
    } 
}
